import { validateNumber, validateString } from 'avilatek-utils';
import { Product, Variant } from '../../models';

type TValidateUpdateVariantForm = {
  action: 'create' | 'update';
  variant: Partial<Variant>;
  product: Product;
};

export function validateUpdateVariantForm({
  action,
  product,
  variant,
}: TValidateUpdateVariantForm): string {
  const {
    stock,
    sku,
    price,
    compareAtPrice,
    agreedPrice,
    option,
    electronicCodes,
    codesAutogenerated,
  } = variant;
  const { options } = product;
  const { option1, option2, option3 } = option;
  // validate stock is integer
  if (!validateNumber(stock) || stock < 0 || !Number.isInteger(Number(stock))) {
    return 'El stock de la variante es inválido';
  }

  if (!validateString(sku) || String(sku).length > 127) {
    return 'El sku de la variante es inválido';
  }

  if (!validateNumber(price) || price < 0) {
    return 'El precio de la variante es inválido';
  }

  if (!validateNumber(compareAtPrice) || compareAtPrice < price) {
    return 'El precio de comparación de la variante es inválido';
  }

  if (
    !validateNumber(agreedPrice) ||
    agreedPrice > price ||
    agreedPrice > compareAtPrice
  ) {
    return 'El precio acordado de la variante es inválido, tiene que ser menor al precio y al precio de comparación';
  }

  if (options.length > 0 && !validateString(option1)) {
    return `El valor de la opción ${options[0].name} es inválido`;
  }

  if (options.length > 1 && !validateString(option2)) {
    return `El valor de la opción ${options[1].name} es inválido`;
  }

  if (options.length > 2 && !validateString(option3)) {
    return `El valor de la opción ${options[2].name} es inválido`;
  }
  if (
    action === 'create' &&
    electronicCodes.length === 0 &&
    !codesAutogenerated
  ) {
    return 'Es necesario agregar códigos a la variante';
  }

  return '';
}
